import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function tipomonedaComboReducer(state= initialState.tipomonedaCombo, action){
	switch(action.type){
		case types.GET_TIPOMONEDAS_COMBO_SUCCESS:		            
			return action.datos;		
	
		default:
			return state;
	}
}